module.exports = __webpack_public_path__ + "img/image_background2x.709089e8.jpg";